// Artistas destacados de la home. A diferencia de las colecciones de
// eventos (múltiples, asignadas a slots), los artistas destacados son
// una ÚNICA lista ordenada gestionada por el admin. Se persiste como
// un documento Cosmos singleton; el orden del array define la posición.
import { z } from 'zod';

/**
 * Referencia a un artista dentro de la lista destacada. El `artistId`
 * es el id del Core (B2C autenticado). `position` es 0-based.
 */
export const FeaturedArtistRefSchema = z.object({
  artistId: z.string().min(1),
  position: z.number().int().nonnegative(),
});
export type FeaturedArtistRef = z.infer<typeof FeaturedArtistRefSchema>;

/**
 * Item admin del singleton — lo que devuelve `GET /admin/featured-artists`.
 * Incluye `_etag` para concurrencia optimista en el `PUT`.
 */
export const FeaturedArtistsAdminItemSchema = z.object({
  artists: z.array(FeaturedArtistRefSchema),
  updatedAt: z.string().nullable(),
  _etag: z.string().optional(),
});
export type FeaturedArtistsAdminItem = z.infer<
  typeof FeaturedArtistsAdminItemSchema
>;

/**
 * Input del `PUT /admin/featured-artists`. El orden del array define la
 * posición; se reemplaza la lista entera (no es un delta).
 */
export const UpdateFeaturedArtistsInputSchema = z.object({
  artistIds: z.array(z.string().min(1)),
});
export type UpdateFeaturedArtistsInput = z.infer<
  typeof UpdateFeaturedArtistsInputSchema
>;

/**
 * Resultado del buscador de artistas del admin
 * (`GET /admin/artists/search?q=`).
 */
export const ArtistSearchAdminItemSchema = z.object({
  id: z.string(),
  name: z.string(),
  slug: z.string().optional(),
  avatarUrl: z.string().optional(),
});
export type ArtistSearchAdminItem = z.infer<typeof ArtistSearchAdminItemSchema>;

/**
 * DTO público de un artista destacado para la home
 * (`GET /v1/home/artists`).
 */
export const FeaturedArtistPublicSchema = z.object({
  id: z.string(),
  name: z.string(),
  slug: z.string().optional(),
  avatarUrl: z.string().optional(),
});
export type FeaturedArtistPublic = z.infer<typeof FeaturedArtistPublicSchema>;

export const FeaturedArtistsPublicResponseSchema = z.object({
  artists: z.array(FeaturedArtistPublicSchema),
});
export type FeaturedArtistsPublicResponse = z.infer<
  typeof FeaturedArtistsPublicResponseSchema
>;
